"use client";

import React, { useState } from "react";

// Define prop types
interface ButtonProps {
  value: string;
  size: "md" | "lg"; // You can add more sizes if needed
  color: string; // Assuming you want to pass color as a prop, although it's not used in your logic yet
}

const Botton: React.FC<ButtonProps> = ({ value, size }) => {
  const [hovered, setHovered] = useState<boolean>(false);

  const handleMouseOver = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  return (
    <div
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      className={`relative overflow-hidden cursor-pointer ${
        size === "md"
          ? "text-md h-[2vh] w-[8vh]"
          : `text-3xl md:text-${size} h-[7vh] w-[28vh] rounded-full border border-spacing-1 border-gray-900`
      } font-bold inline-block`} // Adjust to fit the text size
    >
      {/* Original Text */}
      {size === "md" ? (
        <>
          <span
            className={`absolute left-0 h-full text-white w-full transition-transform text-center justify-center ${
              hovered ? `-translate-y-full` : "translate-y-0"
            } duration-300`}
          >
            {value}
          </span>

          {/* Copy of Text Entering from Bottom */}
          <span
            className={`absolute left-0 w-full transition-transform text-center justify-center text-white duration-300 ${
              hovered ? "translate-y-0" : "translate-y-full"
            }`}
          >
            {value}
          </span>
        </>
      ) : (
        <>
          <div className="relative h-full w-full">
            {/* First Span */}
            <span
              className={`absolute top-0 left-0 z-10 h-full w-full items-center flex justify-center transition-transform duration-300 ${
                hovered ? "text-black" : "text-white"
              }`}
            >
              {value}
            </span>

            {/* Second Span */}
            <span
              className={`absolute top-0 left-0 z-0 h-full w-full bg-black flex items-center justify-center transition-transform duration-300 ${
                hovered
                  ? "text-black -translate-y-full"
                  : "translate-y-0 text-white"
              }`}
            ></span>
          </div>

          {/* Copy of Text Entering from Bottom */}
          <span
            className={`absolute left-0 z-0 bg-white h-full w-full transition-transform text-center justify-center duration-300 ${
              hovered ? "translate-y-0" : "translate-y-full"
            }`}
          ></span>
        </>
      )}
    </div>
  );
};

export default Botton;
